import React, { useState } from 'react';
import { Typography, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar, IconButton, Box } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';
import Currency from '../../../commonModules/Currency';
import { SearchRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import SpendingDetails from './SpendingDetails';
import { toast } from 'react-toastify';
import { getSpendingInfo } from '../../../../../../jsx/actions/paymentAction';
import { useDispatch } from 'react-redux';
import { isEmpty, size } from 'lodash';

const LinkSpending = (props) => {
    const dispatch = useDispatch();
    const [spending, setSpending] = useState({});
    const [noMatch, setNoMatch] = useState(false);
    const [errors, setErrors] = useState({
        spendingID: ""
    });

    const getSpending = async () => {
        if (props.spendingID) {
            try {
                const res = await dispatch(getSpendingInfo(props.spendingID));
                console.log('====================================');
                console.log({ res });
                console.log('====================================');
                if (!res.error && res.spending_amount !== 0) {
                    setSpending(res);
                    setErrors({ spendingID: "" });
                } else {
                    setNoMatch(true);
                }
            } catch (error) {
                console.error('Error fetching spending:', error);
            }
        } else {
            setErrors({
                spendingID: "Veuillez remplir ce champ"
            });
        }
    };

    const handleChange = (e) => {
        setSpending({});
        setNoMatch(false);
        props.handleChange(e);
    };

    const validate = async () => {
        console.log('🔍 validate() appelée');
        console.log('spending:', spending);
        console.log('props.spendingID:', props.spendingID);
        console.log('props.totalPay:', props.totalPay);
        console.log('noMatch:', noMatch);
        if (!isEmpty(spending)) {
            if (noMatch || isEmpty(props.spendingID)) {
                console.log('⚠️ Validation échouée: noMatch ou spendingID vide');
                toast.error("Aucune dépense correspond à cet ID");
                return;
            }
            if (spending.spending_rest_to_match < props.totalPay || !spending.spending_rest_to_match) {
                console.log('====================================');
                console.log('❌ Montant dépense insuffisant - Détails:');
                console.log('spending.spending_rest_to_match:', spending.spending_rest_to_match);
                console.log('props.totalPay:', props.totalPay);
                console.log('Comparaison:', spending.spending_rest_to_match, '<', props.totalPay, '=', spending.spending_rest_to_match < props.totalPay);
                console.log('spending_rest_to_match est falsy?', !spending.spending_rest_to_match);
                console.log('Objet spending complet:', spending);
                console.log('props.spendingID:', props.spendingID);
                console.log('====================================');
                toast.error("Montant dépense insuffisant ");
            } else {
                console.log('✅ Validation réussie - Appel de handleSubmitLink');
                console.log('spending passé à handleSubmitLink:', spending);
                console.log('Type de spending:', typeof spending);
                console.log('Clés de spending:', Object.keys(spending || {}));
                
                // Vérification de sécurité avant d'appeler handleSubmitLink
                if (!spending || typeof spending !== 'object') {
                    console.error('❌ ERREUR: spending est invalide:', spending);
                    toast.error("Erreur: données de dépense invalides");
                    return;
                }
                
                try {
                    props.handleSubmitLink(spending);
                } catch (error) {
                    console.error('❌ ERREUR dans handleSubmitLink:', error);
                    console.error('Stack trace:', error.stack);
                    toast.error("Erreur lors de la liaison de la dépense: " + (error.message || error));
                }
            }
        }
    };

    return (
        <PopUp
            title={props.title || "Pointer les dépenses "}
            close={props.handleClose}
            submitAction={isEmpty(spending) ? getSpending : validate}
            submitTitle={isEmpty(spending) ? "Rechercher" : "Valider"}
            submitColor={isEmpty(spending) && "primary"}
            appbar
        >
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <InputText
                        label="ID Dépense 5000"
                        value={props.spendingID}
                        required
                        name="spendingID"
                        onChange={handleChange}
                        error={errors.spendingID}
                        endAction={!isEmpty(props.spendingID) && (
                        <IconButton onClick={getSpending}>
                            <SearchRounded color="secondary" />
                        </IconButton>
                        )}
                    />
                    <Box p={1}>
                        {!noMatch && !isEmpty(spending) && <SpendingDetails spending={spending} />}
                        {noMatch && <Alert severity="warning">Dépense introuvable</Alert>}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <List style={{ maxHeight: "500px", overflow: "auto" }}>
                        <ListItem>
                            <ListItemText primary={<Typography variant="body1">Total</Typography>} />
                            <ListItemSecondaryAction>
                                <ListItemText
                                    secondary={
                                        <Typography variant="h6" color="secondary">
                                            <Currency value={props.totalPay} />
                                        </Typography>
                                    }
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                        {props.children}
                    </List>
                </Grid>
            </Grid>
        </PopUp>
    );
};

export default LinkSpending;
